import { SetStateAction, Dispatch } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { UploaderPreviewControl } from "../UploaderPreviewControl/UploaderPreviewControl.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import styles from "./styles.module.scss";

interface UploaderHeaderI {
  listView: boolean;
  setListView: Dispatch<SetStateAction<boolean>>;
}

export const UploaderHeader = ({ listView, setListView }: UploaderHeaderI) => {
  const { getUploading } = useUploader();
  const { uploaderGetFiles } = useUploader();

  return getUploading() || uploaderGetFiles().length < 1 ? null : (
    <div className={styles.content}>
      <UploaderPreviewControl />
      <div className={styles.grid}>
        <Tooltip top start tooltipTextKey={"uploader-thumbreview-view-tooltip"}>
          <div
            className={`${styles.iconWrap} ${!listView ? styles.selected : ""}`}
            onClick={() => {
              setListView(false);
            }}
          >
            <Icon name={"home/thumbreview_icon"} />
          </div>
        </Tooltip>
        <Tooltip top end tooltipTextKey={"uploader-list-view-tooltip"}>
          <div
            className={`${styles.iconWrap} ${listView ? styles.selected : ""}`}
            onClick={() => {
              setListView(true);
            }}
          >
            <Icon name={"home/listpreview_icon"} />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};
